export class TagEventDataVO {
    paramsVO;
    resize;
    online;
    playerContainer;
    resourceConfig;
    fatalError;
    playerNumber;
    adaptedPlayerInstance;
    adaptedPlayerEvent;
    player;
    playerAdapterEvent;
    playerEvent;
    eventCallback;
    executionDelay;
    latestHDCPSupported;
    promiseResolve;
    promiseReject;
    importerError;
}
